import { useRouteTo } from '@vt/hooks'
import { useNavigate } from 'react-router-dom'
import NavigateAdaptor from './adaptor'

function useDomRouteTo(props) {
  const navigate = useNavigate()
  const ret = useRouteTo(new NavigateAdaptor(navigate), props)
  return ret
}

export default useDomRouteTo
